import axios from 'axios';
import config from '../config/config';

const authApi = {
  async register(username, email, password) {
    try {
      const res = await axios.post(`${config.API_BASE_URL}/register`, { username, email, password });
      
      // ถ้า register สำเร็จ และมี token และ user กลับมา ให้เก็บไว้ใน localStorage
      if (res.data.token && res.data.user) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        return { success: true, message: res.data.msg, token: res.data.token, user: res.data.user };
      }
      
      return { success: true, message: res.data.msg };
    } catch (error) {
      console.error("Registration API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Registration failed');
    }
  },

  async login(username, password) {
    try {
      const res = await axios.post(`${config.API_BASE_URL}/login`, { username, password });
      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      return { success: true, token, user };
    } catch (error) {
      console.error("Login API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Login failed');
    }
  },

  async getProfile() {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token found');

    try {
      const res = await axios.get(`${config.API_BASE_URL}/profile`, {
        headers: {
          'x-auth-token': token // ส่ง Token ไปด้วย
        }
      });
      return { success: true, user: res.data };
    } catch (error) {
      console.error("Get Profile API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Failed to fetch profile');
    }
  },

  async updateProfile(newProfileData) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token found');

    try {
      const res = await axios.put(`${config.API_BASE_URL}/profile/update`, newProfileData, {
        headers: {
          'x-auth-token': token
        }
      });
      // อัปเดต localStorage ด้วยข้อมูลที่ Backend ส่งกลับมา
      localStorage.setItem('user', JSON.stringify(res.data.user));
      return { success: true, user: res.data.user, message: res.data.msg };
    } catch (error) {
      console.error("Update Profile API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Failed to update profile');
    }
  },

  async updatePassword(passwordData) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token found');

    try {
      const res = await axios.put(`${config.API_BASE_URL}/profile/update-password`, passwordData, {
        headers: {
          'x-auth-token': token
        }
      });
      return { success: true, message: res.data.msg };
    } catch (error) {
      console.error("Update Password API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Failed to update password');
    }
  },

  async getLoginLogs(page = 1, limit = 10) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token found');

    try {
      const res = await axios.get(`${config.API_BASE_URL}/analytics/login-logs`, {
        headers: {
          'x-auth-token': token
        },
        params: { page, limit }
      });
      return { success: true, ...res.data };
    } catch (error) {
      console.error("Get Login Logs API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Failed to fetch login logs');
    }
  },

  async submitHelpMessage(message, subject = 'Help Request') {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token found');

    try {
      const res = await axios.post(`${config.API_BASE_URL}/help/submit`, 
        { message, subject },
        {
          headers: {
            'x-auth-token': token
          }
        }
      );
      return { success: true, ...res.data };
    } catch (error) {
      console.error("Submit Help Message API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Failed to submit help message');
    }
  },

  async getHelpMessages(page = 1, limit = 10) {
    const token = localStorage.getItem('token');
    if (!token) throw new Error('No token found');

    try {
      const res = await axios.get(`${config.API_BASE_URL}/help/messages`, {
        headers: {
          'x-auth-token': token
        },
        params: { page, limit }
      });
      return { success: true, ...res.data };
    } catch (error) {
      console.error("Get Help Messages API error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.msg || 'Failed to fetch help messages');
    }
  },

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    return { success: true, message: 'Logged out successfully.' };
  }
};

export default authApi;
